﻿//WebSite JS file

/* exported FastMarket */
/* globals ArrayOfFunc */
function FastMarket(splitTypeCode)
{
    "use strict";

    var initArray = this.parseCode(splitTypeCode);
    this.StartAfter = parseInt(initArray[1]);
    this.IntervalInMinutes = parseInt(initArray[2] + initArray[3]);
    this.ViewBuilder = this.createViewBuilder(splitTypeCode);
}

FastMarket.prototype.createViewBuilder = function (splitTypeCode) {
    var arr = splitTypeCode.toString();

    if (arr[0] == 1) {
        return new NextMinutes();
    }
    else {
        return new FirstInNextMinutes();
    }
};

FastMarket.prototype.parseCode = function (codeToParse)
{
    "use strict";

    return codeToParse.toString();
};

FastMarket.prototype.formatMinutes = function (minutes)
{
    "use strict";

    if (minutes < 10)
    {
        minutes = "0" + minutes;
    }

    return minutes;
};

FastMarket.prototype.calculateFastMarketInterval = function (lines)
{
    "use strict";

    var values = Array.getValues(lines);

    /* jshint newcap: false */
    var arrayOfParams = ArrayOfFunc(values, function (o)
    {
        return o.QATypeParameter2;
    });
    /* jshint newcap: true */

    var maxParam = Math.max.apply(null, arrayOfParams);
    if (!maxParam)
    {
        return "";
    }

    return this.getFastMarketInterval(maxParam);
};

FastMarket.prototype.getFastMarketInterval = function (fromTime)
{
    "use strict";

    if (fromTime == -1)
    {
        fromTime = 0;
    }

    var startInterval = this.formatMinutes(fromTime + this.StartAfter);
    var endIterval = this.formatMinutes(fromTime + this.StartAfter + this.IntervalInMinutes - 1);

    var res = [];
    res.push(startInterval);
    res.push(endIterval);

    return res;
};

window.FastMarket = FastMarket;
